// c_favorites.js
// お気に入り(ウォッチリスト)機能・#3 フェーズ1
// ブラウザのlocalStorageだけで完結する(ログイン顧客の端末間同期はフェーズ2で別途検討)。
// 保存キー・書き方は既存の「最近見た商品」(theme.js の RecentlyViewedProducts、
// sections/c_main-product.liquid の localStorage 保存処理)と同じパターンに合わせている。

const FAVORITES_STORAGE_KEY = 'theme:favorite-products';
const FAVORITES_CHANGED_EVENT = 'theme:favorites-changed';

function getFavoriteIds() {
  try {
    return Array.from(new Set(JSON.parse(localStorage.getItem(FAVORITES_STORAGE_KEY) || '[]')));
  } catch (e) {
    // Safari のプライベートモードなどで読み書きできない場合は空扱いにする
    return [];
  }
}

function setFavoriteIds(ids) {
  try {
    localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(ids));
  } catch (e) {
    // 保存できなくても画面の動作は続ける(既存の recently-viewed と同じ扱い)
  }
  document.dispatchEvent(new CustomEvent(FAVORITES_CHANGED_EVENT));
}

function extractSectionId(element) {
  element = element.classList.contains('shopify-section') ? element : element.closest('.shopify-section');
  return element.id.replace('shopify-section-', '');
}

class FavoriteButton extends HTMLElement {
  connectedCallback() {
    this.productId = parseInt(this.getAttribute('product-id'), 10);
    this.button = this.querySelector('.favorite-button__toggle');

    if (!this.button || Number.isNaN(this.productId)) return;

    this.onToggle = this.onToggle.bind(this);
    this.updateState = this.updateState.bind(this);

    this.button.addEventListener('click', this.onToggle);
    document.addEventListener(FAVORITES_CHANGED_EVENT, this.updateState);

    this.updateState();
  }

  disconnectedCallback() {
    document.removeEventListener(FAVORITES_CHANGED_EVENT, this.updateState);
  }

  isFavorite() {
    return getFavoriteIds().includes(this.productId);
  }

  updateState() {
    const active = this.isFavorite();
    this.classList.toggle('is-active', active);
    this.button.setAttribute('aria-pressed', String(active));
  }

  onToggle() {
    const ids = getFavoriteIds();
    const index = ids.indexOf(this.productId);

    if (index === -1) {
      ids.unshift(this.productId);
      this.trackAdd();
    } else {
      ids.splice(index, 1);
    }

    setFavoriteIds(ids);
  }

  // どの商品がどれくらいお気に入りされたかを数えるため、GA4 の標準イベント add_to_wishlist を GTM（dataLayer）へ送る。
  // 外したときは送らない（GA4 に標準のイベントが無いため。「入れた回数」で数える）。
  trackAdd() {
    const price = parseFloat(this.dataset.itemPrice);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_wishlist',
      ecommerce: {
        currency: 'JPY',
        value: Number.isNaN(price) ? undefined : price,
        items: [
          {
            item_id: this.dataset.itemId || `shopify_JP_${this.productId}`,
            item_name: this.dataset.itemName || '',
            price: Number.isNaN(price) ? undefined : price
          }
        ]
      }
    });
  }
}

class FavoriteProductsList extends HTMLElement {
  connectedCallback() {
    this.loadProducts();
  }

  async loadProducts() {
    const ids = getFavoriteIds();

    if (ids.length === 0) {
      this.showEmptyState();
      return;
    }

    const query = ids.map((id) => `id:${id}`).join(' OR ');
    const section = this.closest('.shopify-section');
    const url = `${Shopify.routes.root}search?type=product&q=${encodeURIComponent(query)}&section_id=${extractSectionId(section)}`;

    const response = await fetch(url, { priority: 'low' });
    const tempDiv = new DOMParser().parseFromString(await response.text(), 'text/html');
    const favoriteProductsElement = tempDiv.querySelector('favorite-products-list');

    if (favoriteProductsElement && favoriteProductsElement.childElementCount > 0) {
      this.replaceChildren(...document.importNode(favoriteProductsElement, true).childNodes);
    } else {
      this.showEmptyState();
    }
  }

  showEmptyState() {
    const template = this.querySelector('template[data-favorites-empty]');
    if (template) {
      this.replaceChildren(document.importNode(template.content, true));
    }
  }
}

if (!window.customElements.get('favorite-button')) {
  window.customElements.define('favorite-button', FavoriteButton);
}

if (!window.customElements.get('favorite-products-list')) {
  window.customElements.define('favorite-products-list', FavoriteProductsList);
}
